/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_bleeding = function (actor, battleState, buffNode) {
  const node = new YesNoNode(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'healing_prayer')) {
    node.branches[node.NO] = new UseAbility({
      actor,
      abilityHandle: 'healing_prayer',
      altNode: buffNode,
    });
  } else {
    node.branches[node.NO] = buffNode;
  }

  node.suture = BattleCalc.getEquippedAbility(actor, 'suture');
  if (node.suture) {
    node.branches[node.YES] = new UseAbility({
      actor,
      abilityHandle: 'suture',
      altNode: buffNode,
    });
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  node.query = function (target) {
    if (node.yesNoEvalFunction()) {
      return node.branches[node.YES].query(node.best_bleeding_ally_target);
    } else {
      return node.branches[node.NO].query(target);
    }
  };

  node.yesNoEvalFunction = function () {
    return node.suture && !!node.getBestBleedingAllyTarget();
  };

  node.getBestBleedingAllyTarget = function () {
    let allies = BattleCalc.getAlliesOfUnit(
      actor,
      battleState.allUnits,
      true,
      false // never heal summons
    );

    // suture candidates are allies bleeding for more than 10% of their hp
    let candidates = [];
    for (const ally of allies) {
      const bleeding_conditions = BattleCalc.getAllBleedConditions(ally);
      const total_bleed = bleeding_conditions.reduce(
        (acc, c) => acc + c.potency,
        0
      );
      if (total_bleed >= ally.hp * 0.1) candidates.push(ally);
    }

    if (candidates.length > 0) {
      let closest_dist = Infinity;
      let closest_candidate;
      for (const candidate of candidates) {
        const dist = BattleCalc.boardDistance(actor, candidate);
        if (dist < closest_dist) {
          closest_dist = dist;
          closest_candidate = candidate;
        }
      }
      node.best_bleeding_ally_target = closest_candidate;
      return closest_candidate;
    }

    node.best_bleeding_ally_target = null;
    return null;
  };

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.best_bleeding_ally_target = null;
    node.suture = null;
    originalDispose.call(node);
  };

  return node;
};
module.exports = Q_bleeding;
